import React, { useEffect, useState } from "react";
import { useForm, Controller, useFieldArray } from "react-hook-form";
import { get, post } from "../../services/api";
import Select from "react-select";
import { toast } from "react-toastify";

function AssessmentPlanClassWise() {
  const token = localStorage.getItem("token");
  const organizationId = localStorage.getItem("organizationId");
  const savedCenterId =
    localStorage.getItem("centerId") === "null"
      ? null
      : localStorage.getItem("centerId");

  const {
    register,
    formState: { errors, isSubmitting },
    control,
    handleSubmit,
    watch,
    setValue,
    trigger,
    reset,
  } = useForm();

  const [centerId, setCenterId] = useState(savedCenterId || null);
  const [centersData, setCentersData] = useState([]);
  const [centerClassesAssessmentPlan, setCenterClassesAssessmentPlan] =
    useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchCenters = async () => {
      try {
        const response = await get(
          `Dropdown/GetAllCentersByOrganizationId?organizationId=${organizationId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setCentersData(response);

        if (savedCenterId) {
          const selectedCenter = response.find(
            (center) => center.id === parseInt(savedCenterId, 10)
          );
          if (selectedCenter) {
            setValue("centerId", {
              value: selectedCenter.id,
              label: selectedCenter.name,
            });
          }
        }
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCenters();
  }, []);

  useEffect(() => {
    const fetchCenterClassesAssessmentPlanByCenterId = async (id) => {
      setLoading(true);
      try {
        const response = await get(
          `AssessmentPlan/GetCenterClassesAssessmentPlanByCenterIdAsync?centerId=${id}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        const { centerClassesAssessmentPlan } = response;
        setCenterClassesAssessmentPlan(centerClassesAssessmentPlan);
        // reset();
      } catch (error) {
        console.error("Error fetching centerClassesAssessmentPlan:", error);
      } finally {
        setLoading(false);
      }
    };

    // if (centerId > 0) {
    fetchCenterClassesAssessmentPlanByCenterId(centerId);
    // }
  }, [centerId]);

  // const handleCenterDropdownChange = (event) => {
  //   const selectedCenterId = Number(event.target.value);
  //   setCenterId(selectedCenterId);
  //   setCenterClassesAssessmentPlan([]);
  // };

  const saveData = async (data) => {
    if (!token) {
      console.error("Unauthorized.");
      return;
    }

    // toast.error("An unexpected error occurred");
    // return;

    const formData = centerClassesAssessmentPlan.flatMap(
      (centerItem, centerIndex) =>
        centerItem.centerAssessmentPlanDetail.map((detail, detailIndex) => ({
          id: detail.id,
          totalScore:
            data.centerClassesAssessmentPlan[centerIndex]
              ?.centerAssessmentPlanDetail[detailIndex]?.totalScore || 0,
          passingScorePercentage:
            data.centerClassesAssessmentPlan[centerIndex]
              ?.centerAssessmentPlanDetail[detailIndex]
              ?.passingScorePercentage || 0,
          category:
            data.centerClassesAssessmentPlan[centerIndex]
              ?.centerAssessmentPlanDetail[detailIndex]?.category || "string",
          isCompulsory:
            data.centerClassesAssessmentPlan[centerIndex]
              ?.centerAssessmentPlanDetail[detailIndex]?.isCompulsory || false,
        }))
    );

    try {
      const response = await post(
        "AssessmentPlan/UpdateCenterClassesAssessmentTypeAmountAsync",
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.isSuccess) {
        toast.success(response.message || "Success!");
      }
    } catch (error) {
      console.error("Error.", error);
    }
  };

  return (
    <>
      <div className="page-header d-flex mb-2">
        <h2 className="page-heading fs-7">Assessment Plan Class Wise</h2>
      </div>

      <div className="row g-3">
        <div className="col-md-8">
          <div className="card">
            <div className="card-body">
              <form className="" onSubmit={handleSubmit(saveData)}>
                <div className="mb-3" style={{ width: "220px" }}>
                  <label className="form-label">Center</label>
                  <Controller
                    name="centerId"
                    control={control}
                    rules={{ required: "This field is required." }}
                    render={({ field }) => (
                      <Select
                        {...field}
                        options={centersData.map((center) => ({
                          value: center.id,
                          label: center.name,
                        }))}
                        isDisabled={savedCenterId !== "0"}
                        onChange={(selectedOption, actionMeta) => {
                          if (actionMeta.action === "clear") {
                            setValue(`centerId`, null);
                          } else {
                            setValue(
                              `centerId`,
                              selectedOption || { value: 0, label: "" }
                            );
                            setCenterId(selectedOption.value);
                          }
                          trigger(`centerId`);
                        }}
                        className="react-select-style"
                        classNamePrefix="react-select-style-pref"
                        // isClearable={!savedCenterId}
                      />
                    )}
                  />
                  {errors.centerId && (
                    <small className="text-danger">
                      {errors.centerId.message}
                    </small>
                  )}
                </div>

                <div className="row g-3">
                  <div className="col-md-12">
                    {loading ? (
                      <p>Loading...</p>
                    ) : (
                      <table className="table table-bordered custom-table m-0">
                        <thead>
                          <tr>
                            <th>Class</th>
                            <th>Assessment Type</th>
                            <th>Passing Score (%)</th>
                            <th>Total Score</th>
                            <th>Category</th>
                            <th>Compulsory</th>
                          </tr>
                        </thead>
                        <tbody>
                          {!centerClassesAssessmentPlan.length ? (
                            <tr className="text-center w-100">
                              <td colSpan="6">
                                There are no records to display
                              </td>
                            </tr>
                          ) : (
                            centerClassesAssessmentPlan.map(
                              (centerItem, centerIndex) =>
                                centerItem.centerAssessmentPlanDetail.map(
                                  (item, detailIndex) => (
                                    <tr key={item.id}>
                                      {detailIndex === 0 && (
                                        <th
                                          rowSpan={
                                            centerItem
                                              .centerAssessmentPlanDetail.length
                                          }
                                        >
                                          {centerItem.className}
                                        </th>
                                      )}
                                      <td>{item.assessmentTypeName}</td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          {...register(
                                            `centerClassesAssessmentPlan[${centerIndex}].centerAssessmentPlanDetail[${detailIndex}].passingScorePercentage`,
                                            {
                                              valueAsNumber: true,
                                              required:
                                                "Passing score is required",
                                              min: {
                                                value: 0,
                                                message:
                                                  "Percentage cannot be negative",
                                              },
                                              // max: {
                                              //   value: 100,
                                              //   message:
                                              //     "Percentage cannot exceed 100",
                                              // },
                                            }
                                          )}
                                          value={item.passingScorePercentage}
                                          // disabled
                                        />
                                        {errors.centerClassesAssessmentPlan?.[
                                          centerIndex
                                        ]?.centerAssessmentPlanDetail?.[
                                          detailIndex
                                        ]?.passingScorePercentage && (
                                          <div className="text-danger">
                                            {
                                              errors
                                                .centerClassesAssessmentPlan[
                                                centerIndex
                                              ].centerAssessmentPlanDetail[
                                                detailIndex
                                              ].passingScorePercentage.message
                                            }
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        <input
                                          type="number"
                                          className="form-control"
                                          {...register(
                                            `centerClassesAssessmentPlan[${centerIndex}].centerAssessmentPlanDetail[${detailIndex}].totalScore`,
                                            {
                                              valueAsNumber: true,
                                              required:
                                                "Total score is required",
                                              min: {
                                                value: 0,
                                                message:
                                                  "Score cannot be negative",
                                              },
                                            }
                                          )}
                                          value={item.totalScore}
                                          // disabled
                                        />
                                        {errors.centerClassesAssessmentPlan?.[
                                          centerIndex
                                        ]?.centerAssessmentPlanDetail?.[
                                          detailIndex
                                        ]?.totalScore && (
                                          <div className="text-danger">
                                            {
                                              errors
                                                .centerClassesAssessmentPlan[
                                                centerIndex
                                              ].centerAssessmentPlanDetail[
                                                detailIndex
                                              ].totalScore.message
                                            }
                                          </div>
                                        )}
                                      </td>
                                      <td>
                                        <select
                                          className="form-select"
                                          {...register(
                                            `centerClassesAssessmentPlan[${centerIndex}].centerAssessmentPlanDetail[${detailIndex}].category`
                                          )}
                                          value={item.category}
                                          style={{ width: "100px" }}
                                          // disabled
                                        >
                                          <option value="">Select</option>
                                          <option value="Written">
                                            Written
                                          </option>
                                          <option value="Oral">Oral</option>
                                          <option value="Practical">
                                            Practical
                                          </option>
                                        </select>
                                      </td>
                                      <td>
                                        <input
                                          type="checkbox"
                                          className="form-check-input"
                                          {...register(
                                            `centerClassesAssessmentPlan[${centerIndex}].centerAssessmentPlanDetail[${detailIndex}].isCompulsory`
                                          )}
                                          defaultChecked={item.isCompulsory}
                                          // disabled
                                        />
                                      </td>
                                    </tr>
                                  )
                                )
                            )
                          )}
                        </tbody>
                      </table>
                    )}
                  </div>
                  <div className="col-12">
                    <button
                      className="btn btn-primary btn-sm"
                      type="submit"
                      disabled={isSubmitting}
                      // disabled
                    >
                      {isSubmitting ? "Save" : "Save"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AssessmentPlanClassWise;
